// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 管理员登录 校验管理员账号密码并返回 Bearer Token。 POST /api/auth/login */
export async function login(
  body: API.LoginRequest,
  options?: { [key: string]: any }
) {
  return request<API.ApiResultLoginResponse>("/api/auth/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 管理员登出 注销当前登录会话并撤销当前 Bearer Token。 POST /api/auth/logout */
export async function logout(options?: { [key: string]: any }) {
  return request<API.ApiResultMessageResponse>("/api/auth/logout", {
    method: "POST",
    ...(options || {}),
  });
}

/** 获取当前管理员信息 返回当前 Bearer Token 对应的管理员会话信息。 GET /api/auth/me */
export async function me(options?: { [key: string]: any }) {
  return request<API.ApiResultMeResponse>("/api/auth/me", {
    method: "GET",
    ...(options || {}),
  });
}

/** 修改当前管理员密码 修改当前 Bearer Token 对应管理员的登录密码。 POST /api/auth/password */
export async function changePassword(
  body: API.ChangePasswordRequest,
  options?: { [key: string]: any }
) {
  return request<API.ApiResultMessageResponse>("/api/auth/password", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取登录公钥 返回用于登录加密的 RSA 公钥。 GET /api/auth/public-key */
export async function publicKey(options?: { [key: string]: any }) {
  return request<API.ApiResultPublicKeyResponse>("/api/auth/public-key", {
    method: "GET",
    ...(options || {}),
  });
}

/** 注册管理员账号 创建新的管理员账号，需要当前管理员已登录。 POST /api/auth/register */
export async function register(
  body: API.LoginRequest,
  options?: { [key: string]: any }
) {
  return request<API.ApiResultMessageResponse>("/api/auth/register", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
